export const Theme = {
    // Colors
    successColor: `#66ad66`,
    dangerColor: `#eb5757`,
    
    darkBgColor: `#828282`,
    mediumBgColor: `#e5e5e5`,

    // -------------NEW--------------
    // Mobile Theme (default)

    // Colors
    buttonGreen: `#66AD66`,
    buttonRed: `#EB5757`,
    buttonGray: `#828282`,

    inputGray: `#E0E0E0`,
    inputTextGray: `#333333`,

    borderGray: `#BDBDBD`,
    navBarGray: `#F2F2F2`,

    textBlack: `#000000`,
    textWhite: `#FFFFFF`,
    errorRed: `#FF0000`,

    // Button and Input Fields
    buttonHeight: `5rem`,
    buttonWidth: `20rem`,       // all other buttons

    medButtonWidth: `15rem`,    // buttons at the bottom of individual plant page only
    navButtonWidth: `11rem`,   // nav buttons only

    inputHeight: `5rem`,
    inputWidth: `35rem`,
    inputErrorBorder: `2px solid #FF0000`,
    
    // Special inputs
    numberInputWidth: `8rem`,
    dropdownWidth: `13rem`,


    // Mini Buttons
    miniButtonHeight: `3.4rem`, // mini buttons on plant cards and modal window
    miniButtonWidth: `9rem`,


    // Border Radius
    borderRadius: `2.5rem`,     // Standard for buttons and input fields
    miniBorderRadius: `1.7rem`, // mini buttons only


    // Font Sizes
    fontSize: `2.4rem`,         // Standard
    h1FontSize: `3.6rem`,
    cardTitleFontSize: `2.2rem`,
    miniButtonFontSize: `2rem`,
    errorFontSize: `2rem`,
    navBarTitleFontSize: `2.8rem`,


    // Spacing
    space: `2rem`,                  // Standard spacing between items
    navBarSpace: `1rem`,            // Space between nav items
    inputLabelPadding: `1.3rem`,    // Space between input labels and input left/right edges
    inputLabelMargin: `0.4rem`,     // Space between input labels and top of input field
    inputFieldPadding: `1px 1.6rem`,// Space inside input field

    // Nav Item Standards
    navBarHeight: `7rem`,
    navIconSize: `5rem`,
    navBarBorderBottom: `2px solid #BDBDBD`,


    // Card Standards
    cardSize: `45%`,
    cardHeaderHeight: `4rem`,    // White area at the top of cards
    cardBackground: `#E0E0E0`,
    cardBorder: `1px solid #BDBDBD`,
    cardBoxShadow: `2px 2px 4px rgba(0, 0, 0, 0.25)`,
    cardSizeSmall: '16.9rem',
    cardSizeLarge: '22.2rem',


    // Modal Constants
    blurBackground: `rgba(242, 242, 242, .8)`,  // For the element that covers screen
    modalSize: `25rem`,
    modalBorder: `1px solid #BDBDBD`,


    // Logo sizes
    smallLogoSize: `10rem`,
    largeLogoSize: `18.7rem`,

    // Image sizes
    smallImageSize: `15rem`,
    largeImageSize: `30rem`,
}